import $ from "jquery";

if (document.querySelector(".icon-slider")) {
    const iconSliders = document.querySelectorAll(".icon-slider__slider");
    iconSliders.forEach(iconSlider => {
        $(iconSlider).slick({
            slidesToShow: 6,
            arrows: false,
            dots: true,
            appendDots: $(iconSlider.closest(".icon-slider").querySelector(".icon-slider__dots")),
            slidesToScroll: 6,
            responsive: [
                {
                    breakpoint: 768,
                    settings: {
                        slidesToShow: 3,
                        slidesToScroll: 3
                    }
                }
            ]
        });
    });
}